import { IDefineCommand } from 'core-ts-types';
import { ScheduleQuery } from '../queries/schedule_query';

angular
  .module('capability-ng-course-schedule')
  .factory(
    'courseDetailCommand',
    function courseDetailCommandDefinition(
      $q: ng.IQService,
      $http: ng.IHttpService,
      ngScheduleQuery: ScheduleQuery,
      defineCommand: IDefineCommand
    ) {
      return defineCommand('courseDetailCommand', function courseDetailCommand(deferred, id) {
        const courseDetail = ngScheduleQuery.getCourseDetail(id);
        deferred.resolve(courseDetail);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/commands/course_detail_command.ts